import {useState} from "preact/compat";

export const useSatisfactionSurvey = () => {
    // State to control whether the modal should be expanded or narrowed
    const [isExpanded, setIsExpanded] = useState(false);

    // Procedure to handle the modal expand action
    const handleExpandAction = (props) => {
        // Destructured props
        const {action} = props;

        // Actually handles the targeted action
        setIsExpanded(action.toUpperCase() === "EXPAND");
    }

    return {
        isExpanded,
        handleExpandAction
    }
}
